import { createReducer, on } from '@ngrx/store';
import * as ErrorActions from './error.actions';
import { ErrorState } from './model/error.model';

export const initialState: ErrorState = {
  errors: [],
};

export const errorReducer = createReducer(
  initialState,
  on(ErrorActions.addError, (state, { id, msg, code, pageId }) => ({
    ...state,
    errors: [...state.errors, { id, msg, code, pageId }],
  })),
  on(ErrorActions.removeError, (state, { id }) => ({
    ...state,
    errors: state.errors.filter(error => error.id !== id),
  })),
  on(ErrorActions.removeErrorsByPageId, (state, { pageId }) => ({
    ...state,
    errors: state.errors.filter(error => error.pageId !== pageId),
  }))
);
